import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./PgOwnerRegistration.css";
import API from "./config/API";

const PgOwnerRegistration = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const locationReferralCode = location.state?.referralCode || "";

  const [formData, setFormData] = useState({
    pgOwnerName: "",
    pgOwnerContactNo: "",
    pgOwnerEmailId: "",
    pgName: "",

    state: "",
    district: "",
    city: "",
    pgAddress: "",
    pgGoogleMapUrl: "",

    pgLocation: "",
    pgType: "",
    subscriptionType: "",

    pgAccountCreatedBy: locationReferralCode ? "Referral_By" : "Self",
    referralCode: locationReferralCode,
    requestedFloorCount: "",

    pgVerifiedByAdminStatus:
      "Approval Pending. Please wait for Admin Approval.",
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    if (locationReferralCode) {
      setFormData((prev) => ({
        ...prev,
        pgAccountCreatedBy: "Referral_By",
        referralCode: locationReferralCode,
      }));
    }
  }, [locationReferralCode]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear message when user starts editing
    if (message) {
      setMessage("");
      setMessageType("");
    }
  };

  const handleAccountCreatedByChange = (e) => {
    const value = e.target.value;

    setFormData((prev) => ({
      ...prev,
      pgAccountCreatedBy: value,
      referralCode: value === "Referral_By" ? prev.referralCode : "",
    }));
  };

  const isValidEmail = (email) => {
    return /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(
      email.trim(),
    );
  };

  const isValidContact = (contact) => {
    return /^[6-9]\d{9}$/.test(contact);
  };

  const isValidGoogleMapUrl = (url) => {
    if (!url || url.trim() === "") {
      return true;
    }

    return /^https?:\/\/(www\.)?(google\.[a-z.]+\/maps|maps\.google\.[a-z.]+|goo\.gl\/maps)/i.test(
      url.trim(),
    );
  };

  const validateForm = () => {
    if (!formData.pgOwnerName.trim()) {
      setMessage("Please enter PG Owner Name.");
      setMessageType("error");
      return false;
    }

    if (!formData.pgOwnerContactNo) {
      setMessage("Please enter Contact Number.");
      setMessageType("error");
      return false;
    }

    if (!isValidContact(formData.pgOwnerContactNo)) {
      setMessage("Please enter a valid 10-digit Indian mobile number.");
      setMessageType("error");
      return false;
    }

    if (!formData.pgOwnerEmailId.trim()) {
      setMessage("Please enter Email Address.");
      setMessageType("error");
      return false;
    }

    if (!isValidEmail(formData.pgOwnerEmailId)) {
      setMessage("Please enter a valid Email Address.");
      setMessageType("error");
      return false;
    }

    if (!formData.pgName.trim()) {
      setMessage("Please enter PG Name.");
      setMessageType("error");
      return false;
    }

    if (!formData.state.trim()) {
      setMessage("Please enter State.");
      setMessageType("error");
      return false;
    }

    if (!formData.district.trim()) {
      setMessage("Please enter District.");
      setMessageType("error");
      return false;
    }

    if (!formData.city.trim()) {
      setMessage("Please enter City.");
      setMessageType("error");
      return false;
    }

    if (!formData.pgLocation.trim()) {
      setMessage("Please enter PG Location / Area.");
      setMessageType("error");
      return false;
    }

    if (!formData.pgType) {
      setMessage("Please select PG Type.");
      setMessageType("error");
      return false;
    }

    if (!formData.subscriptionType) {
      setMessage("Please select Subscription Type.");
      setMessageType("error");
      return false;
    }

    if (
      formData.pgAccountCreatedBy === "Referral_By" &&
      !formData.referralCode.trim()
    ) {
      setMessage("Please enter Referral Code.");
      setMessageType("error");
      return false;
    }

    if (!isValidGoogleMapUrl(formData.pgGoogleMapUrl)) {
      setMessage("Please enter a valid Google Maps URL.");
      setMessageType("error");
      return false;
    }

    if (!formData.requestedFloorCount) {
      setMessage("Please enter how many floors your PG has.");
      setMessageType("error");
      return false;
    }

    const floorCount = Number(formData.requestedFloorCount);

    if (!Number.isInteger(floorCount) || floorCount < 1) {
      setMessage("Please enter a valid floor count. Minimum is 1.");
      setMessageType("error");
      return false;
    }

    if (floorCount > 100) {
      setMessage("Floor count cannot be more than 100.");
      setMessageType("error");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);
    setMessage("");
    setMessageType("");

    try {
      const payload = {
        pgOwnerName: formData.pgOwnerName.trim(),

        pgOwnerContactNo: Number(formData.pgOwnerContactNo),

        pgOwnerEmailId: formData.pgOwnerEmailId.trim(),

        pgName: formData.pgName.trim(),

        state: formData.state.trim(),
        district: formData.district.trim(),
        city: formData.city.trim(),

        pgAddress: formData.pgAddress.trim(),
        requestedFloorCount: Number(formData.requestedFloorCount),

        pgGoogleMapUrl: formData.pgGoogleMapUrl.trim(),

        pgLocation: formData.pgLocation.trim(),

        pgType: formData.pgType,

        subscriptionType: formData.subscriptionType,

        pgAccountCreatedBy: formData.pgAccountCreatedBy,

        referralCode:
          formData.pgAccountCreatedBy === "Referral_By"
            ? formData.referralCode.trim()
            : null,

        pgVerifiedByAdminStatus:
          "Approval Pending. Please wait for Admin Approval.",
      };

      console.log("PG Owner Registration Payload:", payload);

      const response = await fetch(
        `${API.V2}/pgOwner/createPgOwnerRegistration`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(user?.jwtToken
              ? {
                  Authorization: `Bearer ${user.jwtToken}`,
                }
              : {}),
          },
          body: JSON.stringify(payload),
        },
      );

      const data = await response.json();

      console.log("Registration Response:", data);

      if (response.ok && data?.statusCode === 200) {
        setMessage(
          data?.message ||
            "Registration successful. OTP sent to your email/mobile.",
        );
        setMessageType("success");

        /*
         * Do not store OTP in localStorage.
         *
         * Send only the email and mobile number to the OTP page.
         */
        setTimeout(() => {
          navigate("/pgOwnerRegistrationOtp", {
            state: {
              pgOwnerEmailId: formData.pgOwnerEmailId.trim(),
              mobileNumber: Number(formData.pgOwnerContactNo),
            },
          });
        }, 1000);
      } else {
        setMessage(
          data?.message ||
            "Registration failed. Please check the details and try again.",
        );
        setMessageType("error");
      }
    } catch (error) {
      console.error("Registration Error:", error);

      setMessage("Unable to connect to server. Please try again later.");
      setMessageType("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pg-owner-registration-page">
      <div className="pg-owner-registration-card">
        <div className="registration-header">
          <h1>PG Owner Registration</h1>
          <p>Register your PG and start managing your property</p>
        </div>

        <form onSubmit={handleSubmit}>
          {/* Owner Details */}
          <div className="section-title">
            <span>👤</span>
            Owner Details
          </div>

          <div className="form-grid">
            <div className="form-group">
              <label>
                PG Owner Name <span>*</span>
              </label>

              <input
                type="text"
                name="pgOwnerName"
                value={formData.pgOwnerName}
                onChange={handleChange}
                placeholder="Enter owner Full Name"
                maxLength={100}
              />
            </div>

            <div className="form-group">
              <label>
                Contact Number <span>*</span>
              </label>

              <input
                type="tel"
                name="pgOwnerContactNo"
                value={formData.pgOwnerContactNo}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");

                  if (value.length <= 10) {
                    setFormData((prev) => ({
                      ...prev,
                      pgOwnerContactNo: value,
                    }));
                  }
                }}
                placeholder="Enter 10-digit mobile number"
                maxLength={10}
              />
            </div>

            <div className="form-group">
              <label>
                Email Address <span>*</span>
              </label>

              <input
                type="email"
                name="pgOwnerEmailId"
                value={formData.pgOwnerEmailId}
                onChange={handleChange}
                placeholder="Enter Valid Email Address only"
                maxLength={150}
              />
            </div>

            <div className="form-group">
              <label>
                PG Name <span>*</span>
              </label>

              <input
                type="text"
                name="pgName"
                value={formData.pgName}
                onChange={handleChange}
                placeholder="Enter PG name"
                maxLength={150}
              />
            </div>
          </div>

          {/* Location Details */}
          <div className="section-title">
            <span>📍</span>
            PG Location Details
          </div>

          <div className="form-grid">
            <div className="form-group">
              <label>
                State <span>*</span>
              </label>

              <input
                type="text"
                name="state"
                value={formData.state}
                onChange={handleChange}
                placeholder="Enter state"
                maxLength={100}
              />
            </div>

            <div className="form-group">
              <label>
                District <span>*</span>
              </label>

              <input
                type="text"
                name="district"
                value={formData.district}
                onChange={handleChange}
                placeholder="Enter district"
                maxLength={100}
              />
            </div>

            <div className="form-group">
              <label>
                City <span>*</span>
              </label>

              <input
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
                placeholder="Enter city"
                maxLength={100}
              />
            </div>

            <div className="form-group">
              <label>
                PG Location / Area <span>*</span>
              </label>

              <input
                type="text"
                name="pgLocation"
                value={formData.pgLocation}
                onChange={handleChange}
                placeholder="Example: Kukatpally, Hyderabad"
                maxLength={255}
              />
            </div>

            <div className="form-group full-width">
              <label>PG Google Map URL</label>

              <input
                type="url"
                name="pgGoogleMapUrl"
                value={formData.pgGoogleMapUrl}
                onChange={handleChange}
                placeholder="https://maps.google.com/..."
              />

              <small>Optional — paste the Google Maps location URL.</small>
            </div>
          </div>

          {/* PG Configuration */}
          <div className="section-title">
            <span>🏠</span>
            PG Configuration
          </div>

          <div className="form-grid">
            <div className="form-group">
              <label>
                PG Type <span>*</span>
              </label>

              <select
                name="pgType"
                value={formData.pgType}
                onChange={handleChange}
              >
                <option value="">Select PG Type</option>
                <option value="Mens PG">Mens PG</option>
                <option value="Womens PG">Womens PG</option>
                <option value="Co_Living">Co-Living</option>
              </select>
            </div>

            <div className="form-group">
              <label>
                Subscription Type <span>*</span>
              </label>

              <select
                name="subscriptionType"
                value={formData.subscriptionType}
                onChange={handleChange}
              >
                <option value="">Select Subscription</option>
                <option value="Basic">Basic</option>
                <option value="Premium">Premium</option>
                <option value="Gold">Gold</option>
              </select>
            </div>

            <div className="form-group">
              <label>
                How Many Floors does your PG have? <span>*</span>
              </label>

              <input
                type="text"
                name="requestedFloorCount"
                value={formData.requestedFloorCount}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");

                  if (value.length <= 3) {
                    setFormData((prev) => ({
                      ...prev,
                      requestedFloorCount: value,
                    }));
                  }
                }}
                placeholder="Enter number of floors"
                inputMode="numeric"
                maxLength={3}
              />

              <small>Enter numbers only, for example: 1, 2, 3</small>
            </div>

            <div className="form-group">
              <label>Account Created By</label>

              <select
                value={formData.pgAccountCreatedBy}
                onChange={handleAccountCreatedByChange}
              >
                <option value="Self">Self</option>
                <option value="Referral_By">Referral By</option>
              </select>
            </div>

            {formData.pgAccountCreatedBy === "Referral_By" && (
              <div className="form-group">
                <label>
                  Referral Code <span>*</span>
                </label>

                <input
                  type="text"
                  name="referralCode"
                  value={formData.referralCode}
                  onChange={handleChange}
                  placeholder="Enter referral code"
                  maxLength={50}
                  disabled={!!locationReferralCode}
                />
              </div>
            )}

            <div className="form-group">
              <label>Account Status</label>

              <input
                type="text"
                value={formData.pgVerifiedByAdminStatus}
                readOnly
                className="readonly-input"
              />
            </div>
          </div>

          {/* Message */}
          {message && (
            <div
              className={`registration-message ${
                messageType === "success" ? "success-message" : "error-message"
              }`}
            >
              {message}
            </div>
          )}

          {/* Submit */}
          <div className="button-container">
            <button
              type="submit"
              className="register-button"
              disabled={loading}
            >
              {loading ? "Registering..." : "Register PG"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PgOwnerRegistration;
